import React from "react";

// Animated illustration: a professional casino dealer shuffling three cards while a player places a bet on one side.
// All motion is CSS-driven (see .dealer-scene rules in Login.css) on one shared 8s timeline.
function DealerScene() {
  const slots = [
    { x: 210, label: "LEFT" },
    { x: 300, label: "CENTER" },
    { x: 390, label: "RIGHT" },
  ];

  const renderCard = (cls, x) => (
    <g className={`ds-card ${cls}`}>
      <g transform={`translate(${x - 31} 356)`}>
        <rect width="62" height="88" rx="7" fill="#fdf6e3" />
        <rect x="4" y="4" width="54" height="80" rx="5" fill="url(#ds-card-back)" />
        <rect x="4" y="4" width="54" height="80" rx="5" fill="none" stroke="#e8c15a" strokeWidth="1.5" />
        <text x="31" y="51" textAnchor="middle" fontSize="18" fill="#e8c15a" fontWeight="700">
          W3
        </text>
      </g>
    </g>
  );

  return (
    <div className="dealer-scene" aria-hidden="true">
      <svg viewBox="0 0 600 560" className="ds-svg" role="img">
        <defs>
          <radialGradient id="ds-felt" cx="50%" cy="35%" r="70%">
            <stop offset="0%" stopColor="#2b2b2b" />
            <stop offset="100%" stopColor="#050505" />
          </radialGradient>
          <linearGradient id="ds-gold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#f7dc8a" />
            <stop offset="100%" stopColor="#a8761f" />
          </linearGradient>
          <pattern id="ds-card-back" width="10" height="10" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <rect width="10" height="10" fill="#141414" />
            <rect width="5" height="5" fill="#2a2216" />
          </pattern>
          <radialGradient id="ds-spot" cx="50%" cy="0%" r="80%">
            <stop offset="0%" stopColor="rgba(255,230,160,0.35)" />
            <stop offset="100%" stopColor="rgba(255,230,160,0)" />
          </radialGradient>
          <linearGradient id="ds-hair" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2a2d3a" />
            <stop offset="55%" stopColor="#0c0c12" />
            <stop offset="100%" stopColor="#030305" />
          </linearGradient>
          <linearGradient id="ds-dress" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2a2a2a" />
            <stop offset="100%" stopColor="#050505" />
          </linearGradient>
        </defs>

        {/* spotlight */}
        <polygon points="230,0 370,0 590,560 10,560" fill="url(#ds-spot)" />

        {/* ---------- Dealer ---------- */}
        <g className="ds-dealer">
          {/* hair (back): long, sleek and straight, falling past the shoulders */}
          <path
            d="M300 46 Q234 46 232 120 Q230 180 222 240 Q218 280 226 310 L262 310 Q256 260 258 200 L342 200 Q344 260 338 310 L374 310 Q382 280 378 240 Q370 180 368 120 Q366 46 300 46 Z"
            fill="url(#ds-hair)"
          />
          <path d="M240 140 Q234 220 240 300" stroke="#4a5068" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.55" />
          <path d="M360 140 Q366 220 360 300" stroke="#4a5068" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.55" />

          {/* neck */}
          <rect x="286" y="160" width="28" height="40" rx="10" fill="#e9b892" />

          {/* torso: white collared shirt + tailored black vest */}
          <path d="M215 225 Q220 200 262 194 L338 194 Q380 200 385 225 L398 340 L202 340 Z" fill="#fafafa" />
          <path d="M232 214 Q248 200 270 198 L300 300 L300 340 L210 340 Z" fill="url(#ds-dress)" />
          <path d="M368 214 Q352 200 330 198 L300 300 L300 340 L390 340 Z" fill="url(#ds-dress)" />
          {/* shirt collar */}
          <path d="M276 190 L300 210 L286 222 L270 200 Z" fill="#ffffff" stroke="#d8d8d8" strokeWidth="1" />
          <path d="M324 190 L300 210 L314 222 L330 200 Z" fill="#ffffff" stroke="#d8d8d8" strokeWidth="1" />
          {/* vest buttons */}
          <circle cx="300" cy="306" r="3" fill="#e8c15a" />
          <circle cx="300" cy="324" r="3" fill="#e8c15a" />
          {/* bow tie */}
          <path d="M300 212 L282 203 L282 221 Z M300 212 L318 203 L318 221 Z" fill="#9e0f1c" />
          <circle cx="300" cy="212" r="4.5" fill="#7a0a16" />
          {/* name badge */}
          <rect x="316" y="244" width="27" height="10" rx="2" fill="url(#ds-gold)" />
          <text x="329.5" y="251.5" textAnchor="middle" fontSize="5.5" fontWeight="800" fill="#1a1206">DEALER</text>

          {/* long front locks draped over the shoulders */}
          <path d="M250 116 Q244 196 236 272 Q246 280 256 272 Q258 200 266 128 Z" fill="url(#ds-hair)" />
          <path d="M350 116 Q356 196 364 272 Q354 280 344 272 Q342 200 334 128 Z" fill="url(#ds-hair)" />
          <path d="M254 160 Q250 220 246 268" stroke="#4a5068" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.6" />
          <path d="M346 160 Q350 220 354 268" stroke="#4a5068" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.6" />

          {/* face */}
          <ellipse cx="300" cy="118" rx="44" ry="52" fill="#f2c6a0" />
          <circle cx="257" cy="124" r="7" fill="#eab792" />
          <circle cx="343" cy="124" r="7" fill="#eab792" />
          {/* small stud earrings */}
          <circle cx="257" cy="132" r="2.6" fill="#f7dc8a" className="ds-earring" />
          <circle cx="343" cy="132" r="2.6" fill="#f7dc8a" className="ds-earring" />

          {/* eyes: natural liner; blink via CSS */}
          <g className="ds-eyes">
            <path d="M274 120 Q284 112 294 120 Q284 126 274 120 Z" fill="#fff" />
            <path d="M306 120 Q316 112 326 120 Q316 126 306 120 Z" fill="#fff" />
            <circle cx="284" cy="119.5" r="4.4" fill="#3b1d0f" />
            <circle cx="316" cy="119.5" r="4.4" fill="#3b1d0f" />
            <circle cx="285.4" cy="118" r="1.4" fill="#fff" />
            <circle cx="317.4" cy="118" r="1.4" fill="#fff" />
            <path d="M273 120 Q284 110 295 119" stroke="#1a1010" strokeWidth="2" fill="none" strokeLinecap="round" />
            <path d="M327 120 Q316 110 305 119" stroke="#1a1010" strokeWidth="2" fill="none" strokeLinecap="round" />
          </g>
          {/* brows */}
          <path d="M273 106 Q283 100 293 104" stroke="#0a0a10" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          <path d="M307 104 Q317 100 327 106" stroke="#0a0a10" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          <ellipse cx="272" cy="137" rx="7" ry="4" fill="#f19c9c" opacity="0.35" />
          <ellipse cx="328" cy="137" rx="7" ry="4" fill="#f19c9c" opacity="0.35" />
          <path d="M298 128 Q300 134 302 128" stroke="#d29a78" strokeWidth="1.6" fill="none" strokeLinecap="round" />
          {/* friendly smile, soft rose lips */}
          <path d="M289 146 Q300 155 311 146 Q300 150 289 146 Z" fill="#c4505e" />

          {/* hair (front): neat side part */}
          <path d="M256 116 Q252 62 304 60 Q350 62 346 116 Q338 84 312 76 Q290 92 258 104 Q255 110 256 116 Z" fill="url(#ds-hair)" />
          <path d="M296 66 Q316 64 334 80" stroke="#4a5068" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.6" />
        </g>

        {/* ---------- Table ---------- */}
        <ellipse cx="300" cy="420" rx="300" ry="132" fill="url(#ds-gold)" />
        <ellipse cx="300" cy="418" rx="288" ry="122" fill="url(#ds-felt)" />
        <ellipse cx="300" cy="418" rx="250" ry="98" fill="none" stroke="rgba(247,220,138,0.5)" strokeWidth="1.5" strokeDasharray="6 6" />

        {/* bet zones */}
        {slots.map((s, i) => (
          <g key={s.label} className={`ds-zone ds-zone-${i}`}>
            <rect x={s.x - 38} y="456" width="76" height="34" rx="8" fill="rgba(0,0,0,0.18)" stroke="#e8c15a" strokeWidth="1.5" />
            <text x={s.x} y="478" textAnchor="middle" fontSize="11" letterSpacing="1.5" fill="#f7dc8a" fontWeight="700">
              {s.label}
            </text>
          </g>
        ))}

        {/* dealer arms + hands rest on the felt */}
        <g className="ds-arm ds-arm-left">
          <path d="M226 236 Q206 300 238 342" stroke="#fafafa" strokeWidth="26" fill="none" strokeLinecap="round" />
          <path d="M224 330 L240 344" stroke="#141414" strokeWidth="27" strokeLinecap="butt" />
          <ellipse cx="244" cy="350" rx="15" ry="11" fill="#f2c6a0" />
        </g>
        <g className="ds-arm ds-arm-right">
          <path d="M374 236 Q394 300 362 342" stroke="#fafafa" strokeWidth="26" fill="none" strokeLinecap="round" />
          <path d="M376 330 L360 344" stroke="#141414" strokeWidth="27" strokeLinecap="butt" />
          <ellipse cx="356" cy="350" rx="15" ry="11" fill="#f2c6a0" />
        </g>

        {/* three cards being shuffled */}
        {renderCard("ds-card-a", 210)}
        {renderCard("ds-card-b", 300)}
        {renderCard("ds-card-c", 390)}

        {/* ---------- Player placing a bet ---------- */}
        <g className="ds-chip">
          <ellipse cx="390" cy="476" rx="17" ry="9" fill="#5a0a0a" />
          <ellipse cx="390" cy="472" rx="17" ry="9" fill="#d4202a" stroke="#fff" strokeWidth="2" strokeDasharray="5 4" />
          <ellipse cx="390" cy="472" rx="8" ry="4" fill="#fff" />
        </g>
        <g className="ds-player-hand">
          <path d="M520 620 Q470 540 412 490" stroke="#1f3b73" strokeWidth="38" fill="none" strokeLinecap="round" />
          <rect x="404" y="474" width="24" height="10" rx="5" fill="#e6e6e6" transform="rotate(40 416 479)" />
          <ellipse cx="400" cy="478" rx="16" ry="12" fill="#d9a07a" />
        </g>

        {/* "bet placed" badge */}
        <g className="ds-badge">
          <rect x="430" y="404" width="96" height="26" rx="13" fill="url(#ds-gold)" />
          <text x="478" y="421" textAnchor="middle" fontSize="11" fontWeight="800" fill="#1a1206" letterSpacing="1">
            BET PLACED
          </text>
        </g>
      </svg>

      <div className="ds-caption">
        <h2>Watch the shuffle.</h2>
        <p>Pick your side. Win 3X.</p>
      </div>
    </div>
  );
}

export default DealerScene;
